@if (!dismissed()) {
  <div
    aria-atomic="true"
    aria-live="polite"
    class="hx-alert__container"
    role="alert"
    tabindex="-1"
    [attr.aria-describedby]="'alert-description'"
    [attr.aria-labelledby]="title() ? 'alert-title' : null"
    [style.max-width]="width()"
    [style.text-align]="contentJustification()"
    (keydown)="handleKeyDown($event)">
    <!-- Icon -->
    @if (iconName() !== null) {
      <div class="hx-alert__icon-wrapper">
        <hx-icon class="hx-alert__icon" [attr.aria-hidden]="true" [fontIcon]="iconName()!" />
      </div>
    }

    <!-- Content -->
    <div class="hx-alert__content">
      @if (title()) {
        <div class="hx-alert__title" id="alert-title">
          {{ title() }}
        </div>
      }
      @if (description()) {
        <div class="hx-alert__description" id="alert-description">
          {{ description() }}
        </div>
      }

      <!-- Rich content slot for HTML content (e.g., Note component) -->
      <ng-content select="[alertRichContent]" />

      <!-- Action buttons slot -->
      <div class="hx-alert__actions">
        <ng-content />
      </div>
    </div>

    <!-- Close button -->
    @if (dismissible()) {
      <button #closeButton aria-label="Close alert" class="hx-alert__close" type="button" (click)="handleDismiss()">
        <span aria-hidden="true" class="hx-alert__close-icon">×</span>
      </button>
    }
  </div>
}
